import { ELabelColor, IOfferCard } from '../../../types';

export const getIsRosreestrCheckedLabel = ({ isRosreestrChecked }: IOfferCard) => {
  if (!isRosreestrChecked) {
    return null;
  }

  return {
    tooltip: {
      title: 'Продавец указал кадастровый номер',
      description:
        'В объявлении есть информация из Росреестра о собственности, обременениях и налогах на объект недвижимости',
    },
    text: 'Проверено в Росреестре',
    color: ELabelColor.Gray,
  };
};
